<div class="list-wrapper">
  <nz-card class="hero-card">
    <div class="hero-content">
      <div>
        <h2>Customer Directory</h2>
      </div>
      <span class="total-pill" *ngIf="total">Total: {{ total | number }}</span>
    </div>
  </nz-card>

  <nz-card class="table-card">
    <div class="toolbar">
      <div class="toolbar-meta">
        <span>Showing {{ filteredCustomers?.length || 0 }} of {{ total || 0 }}</span>
      </div>

      <div class="toolbar-actions">
        <nz-space>
          <nz-space-item>
            <button nz-button nzType="default" nz-popover nzPopoverTitle="Visible Columns" nzPopoverTrigger="click"
              [nzPopoverContent]="contentTemplate" nzPopoverPlacement="bottomRight">
              <span nz-icon nzType="setting" nzTheme="outline"></span>
            </button>
          </nz-space-item>

          <nz-space-item *ngIf="hasPermissions('download_list')">
            <button nz-button nzType="default" (click)="downloadList()">
              <span nz-icon nzType="download" nzTheme="outline"></span>
            </button>
          </nz-space-item>

          <nz-space-item>
            <nz-badge [nzCount]="nonEmptyFilterCount()">
              <button nz-button nzType="primary" (click)="openDrawer()">
                <span nz-icon nzType="filter" nzTheme="outline"></span>
              </button>
            </nz-badge>
          </nz-space-item>
        </nz-space>
      </div>
    </div>

    <ng-template #contentTemplate>
      <div class="column-selector">
        <label *ngFor="let c of columnNames" nz-checkbox [(ngModel)]="c.visible"
          (ngModelChange)="onVisibleColumnsChange()">{{c.label}}</label>
        <button nz-button nzType="primary" nzBlock (click)="resetColumns()">Reset</button>
      </div>
    </ng-template>

    <div class="table-scroll">
      <nz-table #customerTable class="customers-table" [nzData]="filteredCustomers" [nzFrontPagination]="false"
        [nzTotal]="total" nzBordered [nzPageSize]="pageSize" [nzPageIndex]="pageIndex"
        (nzQueryParams)="onQueryParamsChange($event)" [nzLoading]="isLoading">
        <thead>
          <tr>
            <ng-container *ngFor="let col of columnNames">
              <th *ngIf="col.visible" [nzShowSort]="col.sortable !== false" [nzColumnKey]="col.value"
                [nzSortOrder]="sortName === col.value ? sortValue : null" (nzSortOrderChange)="sort($event, col.value)">
                {{ col.label }}
              </th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let customer of customerTable.data" class="customer-row"
            (click)="showCustomerDetails(customer)">
            <ng-container *ngFor="let col of columnNames">
              <td *ngIf="col.visible">
                <ng-container [ngSwitch]="col.value">
                  <ng-container *ngSwitchCase="'first_name'">
                    <div class="cell-primary">
                      <span class="name">{{ (customer.first_name | titlecase) }} {{ (customer.last_name || '') |
                        titlecase }}</span>
                      <span class="subtext" *ngIf="customer.provider">
                        {{ customer.provider | titlecase }}
                      </span>
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'phone_number'">
                    <span class="cell-primary">{{ customer.phone_number }}</span>
                  </ng-container>

                  <ng-container *ngSwitchCase="'address'">
                    <span class="cell-primary">{{ customer.address }}</span>
                  </ng-container>

                  <ng-container *ngSwitchCase="'rep'">
                    <span class="cell-primary">{{ customer.rep || 'N/A' | titlecase }}</span>
                  </ng-container>

                  <ng-container *ngSwitchCase="'fiber_provider_id'">
                    <span class="cell-primary">{{ customer.provider | titlecase }}</span>
                  </ng-container>

                  <ng-container *ngSwitchCase="'convert_date'">
                    <span class="cell-primary">{{ customer.sale_date | date:'shortDate' }}</span>
                  </ng-container>

                  <ng-container *ngSwitchCase="'install_date'">
                    <span class="cell-primary">{{ customer.install_date | date:'shortDate' }}</span>
                  </ng-container>

                  <ng-container *ngSwitchCase="'provider_status'">
                    <nz-tag class="status-tag" [nzColor]="getStatusColor(customer.status)">
                      {{ customer.status | titlecase }}
                    </nz-tag>
                  </ng-container>

                  <ng-container *ngSwitchCase="'update_date'">
                    <span class="cell-primary">{{ customer.update_date | date:'shortDate' }}</span>
                  </ng-container>

                  <ng-container *ngSwitchCase="'notesArray'">
                    <div class="notes-stack" *ngIf="customer.notesArray?.length">
                      <div *ngFor="let n of customer.notesArray">
                        <span class="note-dot">•</span>
                        <span>{{n.date | date: 'shortDate'}} - {{n.content}}</span>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </td>
            </ng-container>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </nz-card>
</div>


<nz-drawer [nzVisible]="visible" nzPlacement="right" nzTitle="Filter list" (nzOnClose)="close()">
  <ng-container *nzDrawerContent>

    <form nz-form [formGroup]="filterForm" nzLayout="vertical">

      <nz-form-item>
        <nz-form-label>Order Number</nz-form-label>
        <input nz-input formControlName="order_id" />
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Customer</nz-form-label>
        <input nz-input formControlName="name" />
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Phone Number</nz-form-label>
        <input nz-input formControlName="phone_number" />
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Address</nz-form-label>
        <input nz-input formControlName="address" placeholder="Street, city, state or zip" />
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Rep</nz-form-label>
        <input nz-input formControlName="rep" />
      </nz-form-item>

      <nz-form-item *ngIf="!hideProviders">
        <nz-form-label>Provider</nz-form-label>
        <nz-select formControlName="provider" style="width: 100%;">
          <nz-option *ngFor="let p of providersList" [nzLabel]="p.name | titlecase" [nzValue]="p.name"></nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Status</nz-form-label>
        <nz-select formControlName="status" style="width: 100%;">
          <nz-option *ngFor="let s of status" [nzLabel]="s | titlecase" [nzValue]="s"></nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-item [nzLayout]="'vertical'">
        <nz-form-label [nzFor]="'sale_date'">Sale Date Range</nz-form-label>
        <nz-form-control>
          <nz-range-picker formControlName="sale_date" [nzFormat]="'yyyy-MM-dd'" style="width: 100%;">
          </nz-range-picker>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item [nzLayout]="'vertical'">
        <nz-form-label [nzFor]="'install_date'">Install Date Range</nz-form-label>
        <nz-form-control>
          <nz-range-picker formControlName="install_date" [nzFormat]="'yyyy-MM-dd'" style="width: 100%;">
          </nz-range-picker>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item [nzLayout]="'vertical'">
        <nz-form-label [nzFor]="'change_date'">Last Update Date Range</nz-form-label>
        <nz-form-control>
          <nz-range-picker formControlName="change_date" [nzFormat]="'yyyy-MM-dd'" style="width: 100%;">
          </nz-range-picker>
        </nz-form-control>
      </nz-form-item>



    </form>

    <div class="drawer-btns">
      <button nz-button nzType="primary" (click)="search(true)" nzBlock>Search</button>
      <button nz-button nzType="default" (click)="resetFilterForm()" nzBlock>Reset</button>
      <button nz-button nzType="default" (click)="visible = false" nzBlock>Close</button>
    </div>

  </ng-container>
</nz-drawer>
